export const getPlayerStats = () => ({
  person: {
    id: '614c4017f60ae6bf2379793a1',
    singlesInterval: {
      avgDays: 1,
      __typename: 'MatchUpIntervals',
    },
    doublesInterval: {
      avgDays: 14,
      __typename: 'MatchUpIntervals',
    },
    wtnBoundsAllTime: {
      doubles: {
        min: 18.55,
        max: 20.08,
        __typename: 'RatingMinMax',
      },
      singles: {
        min: 21.51,
        max: 24.07,
        __typename: 'RatingMinMax',
      },
      __typename: 'RatingBounds',
    },
    wtnBoundsThisYear: {
      doubles: {
        min: 18.55,
        max: 20.08,
        __typename: 'RatingMinMax',
      },
      singles: {
        min: 21.51,
        max: 24.07,
        __typename: 'RatingMinMax',
      },
      __typename: 'RatingBounds',
    },
    __typename: 'Person',
  },
  matchUpAggregatedCount: {
    uniqueOpponents: {
      count: 4,
      __typename: 'UniqueOpponents',
    },
    __typename: 'AggregatedMatchUpCount',
  },
})
